// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";
import { Route, Routes } from "react-router-dom";
import { useAuth } from "./providers/AuthProvider";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import ConsentGate from "./pages/ConsentGate";
import QuestionPage from "./pages/QuestionPage";
import AboutUs from "./pages/AboutUs";
import Announcement from "./pages/Announcement";
import Constants from "./common/Constants";
import DigitalAgency from "./pages/DigitalAgency";
import DigitalWellBeing from "./pages/DigitalWellBeing";
import DigitalSeafty from "./pages/DigitalSeafty";
import DigitalInfoEcoSystem from "./pages/DigitalInfoEcoSystem";
import MyProgress from "./pages/MyProgress";
import DigitalAmbassador from "./pages/DigitalAmbassador";
import Resources from "./pages/Resources";
import Certificate from "./pages/Certificate";
import CommingSoon from "./pages/CommingSoon";
import StudentProfile from "./pages/StudentProfile";
import ShareFeedback from "./pages/ShareFeedback";
import ThankYou from "./pages/ThankYou";
import BaseLineQuiz from "./pages/BaseLineQuiz";
import SurveyQuiz from "./pages/SurveyQuiz";
import EndLine from "./pages/EndLine";
import SignUp from "./pages/SignUp";
import LoadingSnipQuiz from "./components/LoadingSnipQuiz";

function App() {
  const { isLoggedIn, isLoading, baseLineQuizCompleted, activeQuizType, user } = useAuth();

  return (
    <>
      {
        isLoading ? (
          <Routes>
            <Route path="*" element={<LoadingSnipQuiz />} />
          </Routes>
        ) : (
          <Routes>
            {!isLoggedIn ? (
              <>
                <Route path="/" element={<LoginPage />} />
                <Route path="/sign-up" element={<SignUp />} />
                <Route path="*" element={<LoginPage />} />
              </>
            ) : (!activeQuizType && user?.is_consent === 0) ? (
              /* Consent lives inside the quiz pages, so with neither Baseline nor
                 Survey active there was nothing left to ask for it and the student
                 dropped straight onto the course list. Ask for it here instead. */
              <>
                <Route path="*" element={<ConsentGate />} />
              </>
            ) : baseLineQuizCompleted ? (
              <>
                <Route path="/" element={<HomePage />} />
                <Route path="/home" element={<HomePage />} />
                <Route path="/baseLineQuiz" element={<HomePage />} />
                <Route path="/surveyQuiz" element={<HomePage />} />

                <Route path="/module/digital-safety" element={<DigitalSeafty />} />
                <Route path="/module/digital-wellbeing" element={<DigitalWellBeing />} />
                <Route path="/module/digital-agency" element={<DigitalAgency />} />
                <Route path="/module/digital-infoecosystem" element={<DigitalInfoEcoSystem />} />

                <Route path="/module/digital-safety/items" element={<QuestionPage />} />
                <Route path="/module/digital-wellbeing/items" element={<QuestionPage />} />
                <Route path="/module/digital-agency/items" element={<QuestionPage />} />
                <Route path="/module/digital-infoecosystem/items" element={<QuestionPage />} />
                <Route path="/module/items" element={<QuestionPage />} />

                <Route path="/endline" element={<EndLine />} />
                <Route path="/about-us" element={<AboutUs />} />
                {Constants.SHOW_ANNOUNCEMENTS && <Route path="/annoucement" element={<Announcement />} />}
                <Route path="/myprogress" element={<MyProgress />} />
                <Route path="/digital-ambassador" element={<DigitalAmbassador />} />
                <Route path="/resources" element={<Resources />} />
                <Route path="/certificate" element={<Certificate />} />
                <Route path="/comming-soon" element={<CommingSoon />} />
                <Route path="/profile" element={<StudentProfile />} />
                <Route path="/share-feedback" element={<ShareFeedback />} />
                <Route path="/thank-you" element={<ThankYou />} />
                <Route path="*" element={<HomePage />} />
              </>
            ) : activeQuizType === 'survey' ? (
              <>
                <Route path="/" element={<SurveyQuiz />} />
                <Route path="/surveyQuiz" element={<SurveyQuiz />} />
                <Route path="*" element={<SurveyQuiz />} />
              </>
            ) : (
              <>
                <Route path="/" element={<BaseLineQuiz />} />
                <Route path="/baseLineQuiz" element={<BaseLineQuiz />} />
                <Route path="*" element={<BaseLineQuiz />} />
              </>
            )}
          </Routes>
        )
      }
    </>
  );
}

export default App;
